import React from 'react';
import { FormattedMessage } from 'react-intl';

import S from 'app/features/authentication/components/Register/RegisterAgreement.styled';
import LocalizedLink from 'app/features/localization/components/LocalizedLink/LocalizedLink';
import Text from 'app/components/layout/Text.styled';
import BasicLink from 'app/components/Links/BasicLink.styled';
import { PRIVACY_URL, TERMS_URL } from 'app/router/constants/externalUrls';

const RegisterAgreement = () => (
  <Text
    type="semibold"
    size="s"
    as={S.RegisterAgreement}
    data-t="register-agreement"
  >
    <FormattedMessage
      id="registration_agreement"
      values={{
        termsCta: (
          <BasicLink
            as={LocalizedLink}
            to={TERMS_URL}
            testId="register-agreement-tos"
            infoText
          >
            <FormattedMessage id="registration_terms" />
          </BasicLink>
        ),
        privacyCta: (
          <BasicLink
            as={LocalizedLink}
            to={PRIVACY_URL}
            testId="register-agreement-privacy"
            infoText
          >
            <FormattedMessage id="registration_privacy" />
          </BasicLink>
        ),
      }}
    />
  </Text>
);

RegisterAgreement.displayName = 'RegisterAgreement';

export default RegisterAgreement;
